import { getImageThumbnailUrl, Image } from '@/modules/store/models/Image';
import { PhotoIcon } from '@heroicons/react/24/outline';

interface ImageGalleryProps {
  images: Image[];
  onClick: (image: Image) => void;
  getThumbnailUrl?: (image: Image) => string;
}

const ImageGallery = ({
  images,
  onClick,
  getThumbnailUrl = getImageThumbnailUrl,
}: ImageGalleryProps) => {
  const hasImages = images && images.length > 0;

  return (
    <div>
      {hasImages ? (
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
          {images.map((image, index) => (
            <div
              key={image.url || index}
              className={
                'flex items-center justify-center border rounded-lg bg-gray-50 p-2 cursor-pointer' +
                ' hover:shadow-md hover:border-blue-300 transition'
              }
              onClick={() => onClick(image)}
            >
              <img
                src={getThumbnailUrl(image)}
                alt={`Product image ${index + 1}`}
                className="max-h-60 w-full object-contain rounded-md"
              />
            </div>
          ))}
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center text-gray-400 border rounded-lg bg-gray-50 h-80">
          <PhotoIcon className="w-16 h-16 mb-2" />
          <p>No images available</p>
        </div>
      )}
    </div>
  );
};

export default ImageGallery;
